module.exports = __webpack_public_path__ + "althash-health/static/img/health_1.793135c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/health_1.jpg
// module id = Eawr
// module chunks = 1